<app-messages-center-navigation-tree [treeModel]="messagesCenterNavigationService.customQueuesTree.nodes"
                                     [selectedNode]="messagesCenterNavigationService.currentQueue">
</app-messages-center-navigation-tree>
